var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuscriptionPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 7.34118,
    fill: "#426DD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4909 14.4097C19.587 14.4097 16.7484 15.2708 14.3339 16.8841C11.9194 18.4974 10.0375 20.7905 8.92622 23.4734C7.81495 26.1562 7.52419 29.1083 8.09071 31.9564C8.65723 34.8045 10.0556 37.4207 12.109 39.4741C14.1623 41.5274 16.7785 42.9258 19.6266 43.4923C22.4747 44.0588 25.4268 43.7681 28.1096 42.6568C30.7925 41.5455 33.0856 39.6636 34.6989 37.2491C36.3122 34.8346 37.1733 31.996 37.1733 29.0921L22.4909 29.0921L22.4909 14.4097Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1914 24.8387C44.1914 22.6571 43.7617 20.4968 42.9268 18.4812C42.0919 16.4656 40.8682 14.6341 39.3255 13.0915C37.7829 11.5488 35.9514 10.3251 33.9358 9.49019C31.9202 8.6553 29.7599 8.22559 27.5782 8.22559V24.8387H44.1914Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuscriptionPayments);
export default __webpack_public_path__ + "static/media/SuscriptionPayments.265cc49853d72fb9f5007070a25b7523.svg";
export { ForwardRef as ReactComponent };